// extracted by css-extract-rspack-plugin
export default {"padding":"0","default-padding":"t3ylyx","defaultPadding":"t3ylyx"};